import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_grid_item = _resolveComponent("van-grid-item");
  const _component_van_grid = _resolveComponent("van-grid");
  const _component_PageNavLayoutCpt = _resolveComponent("PageNavLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavLayoutCpt, {
    "show-nav-margin": ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_grid, {
      "column-num": 3,
      gutter: 8
    }, {
      default: _withCtx(() => [_createVNode(_component_van_grid_item, {
        icon: "add-o",
        text: "产品预约",
        to: "/work-wx/appoint/main"
      }), _createVNode(_component_van_grid_item, {
        icon: "chart-trending-o",
        text: "净值查询",
        to: "/work-wx/product/net-worth"
      }), _createVNode(_component_van_grid_item, {
        icon: "user-o",
        text: "我的客户",
        to: "/work-wx/customer/main"
      }), _createVNode(_component_van_grid_item, {
        icon: "orders-o",
        text: "交易管理",
        to: "/work-wx/trade"
      }), _createVNode(_component_van_grid_item, {
        icon: "refund-o",
        text: "赎回管理",
        to: "/work-wx/redemption"
      }), _createVNode(_component_van_grid_item, {
        icon: "search",
        text: "综合查询",
        to: "/work-wx/synthetical"
      })]),
      _: 1
    })]),
    _: 1
  });
}